export const regions = [
  {
    name: 'Hawaii',
    timeZones: ['Pacific/Honolulu'],
  },
  {
    name: 'Alaska',
    timeZones: [
      'America/Anchorage',
      'America/Nome',
      'America/Metlakatla',
      'America/Juneau',
      'America/Sitka',
      'America/Yakutat',
    ],
  },
  {
    name: 'Pacific',
    timeZones: ['America/Los_Angeles', 'America/Vancouver', 'America/Whitehorse'],
  },
  {
    name: 'Mountain',
    timeZones: [
      'America/Denver',
      'America/Dawson',
      'America/Edmonton',
      'America/Boise',
      'America/Yellowknife',
      'America/Inuvik',
      'America/Cambridge_Bay',
    ],
  },
  {
    name: 'Central',
    timeZones: [
      'America/Indiana/Tell_City',
      'America/Indiana/Knox',
      'America/Menominee',
      'America/North_Dakota/Beulah',
      'America/North_Dakota/New_Salem',
      'America/North_Dakota/Center',
      'America/Rankin_Inlet',
      'America/Resolute',
      'America/Rainy_River',
      'America/Winnipeg',
    ],
  },
  {
    name: 'Eastern',
    timeZones: [
      'America/New_York',
      'America/Indiana/Marengo',
      'America/Indiana/Vincennes',
      'America/Indiana/Indianopolis',
      'America/Indiana/Petersberg',
      'America/Indiana/Winamac',
      'America/Indiana/Vevay',
      'America/Kentucky/Louisville',
      'America/Kentucky/Monticello',
      'America/Detroit',
      'America/Iqaluit',
      'America/Pangnirtung',
      'America/Thunder_Bay',
      'America/Toronto',
      'America/Nipigon',
      'America/Atikokan',
    ],
  },
  {
    name: 'Atlantic',
    timeZones: ['America/Goose_Bay', 'America/Moncton', 'America/Glace_Bay', 'America/Halifax'],
  },
  {
    name: 'Newfoundland',
    timeZones: ['America/St_Johns'],
  },
];

export const getRegionForTimeZone = timeZone => {
  const detectedRegion = regions.find(region => region.timeZones.indexOf(timeZone) > -1);

  if (!detectedRegion) return null;

  return detectedRegion;
};

export const getFirstTimeZoneForRegion = regionName => {
  const detectedRegion = regions.find(region => regionName === region.name);

  if (!detectedRegion) return null;

  // We have placed the most popular timezone first for each region
  return detectedRegion.timeZones[0];
};

export default {
  regions,
  getRegionForTimeZone,
  getFirstTimeZoneForRegion,
};
